// Lib
import { handleActions } from 'redux-actions';

// Actions
import { SetPreview } from '@actions/preview';

type PreviewState = boolean;

export default handleActions<PreviewState, void>(
  {
    [SetPreview.toString()]: (state: PreviewState): PreviewState => !state,
  },
  false,
);
